import styled from 'styled-components';

export const StyledMessageWrapper = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  top: -1px;
`;

export const StyledMessage = styled.span<{ maxMessageRows: number }>`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  display: -webkit-box;
  line-clamp: ${({ maxMessageRows }) => maxMessageRows};
  -webkit-line-clamp: ${({ maxMessageRows }) => maxMessageRows};
  -webkit-box-orient: vertical;
`;
